<div class="sidebar-primary-button">
  <a
    routerLink="{{ link }}"
    mat-flat-button
    color="{{ colors }}"
    class="{{ colors }} sidebar-primary-button-inner"
  >
    <mat-icon
      [style.transform]="rotate ? 'rotate(90deg)' : ''"
      class="sidebar-primary-button-icon"
      [class.active]="colors == 'accent'"
      fontSet="material-symbols-outlined"
      >{{ icon }}</mat-icon
    >
    <ng-content />
  </a>
</div>
